import { IContact } from 'clickNgo/entities/contact'

export function renderFullNameColumn(contact: IContact) {
  const firstName = contact.firstName.slice(0, 1).toUpperCase() + contact.firstName.slice(1)
  const lastName = contact.lastName.slice(0, 1).toUpperCase() + contact.lastName.slice(1)
  const fullName = [firstName, lastName].filter(Boolean).join(' ') || '-'
  return <span>{fullName}</span>
}
